import Vue from 'vue'
import { store } from '@/store/index'
import { cookieUtil } from '@/utils/cookie'
const commonFun = {
  $loginModal: function () {
    if (!store.state.isLogin) {
      this.$warning({
        title: '提示',
        content: '暂未登录，请登录后进行相关操作。',
        okText: '确定',
        centered: true,
        closable: true,
        onOk () {
          // location.href = 'https://www.zjzwfw.gov.cn/'
        }
      })
    } else {
      return true
    }
  },
  $toLogin: function (index) {
    const lastUrl = location.href
    document.cookie = 'redirect' + '=' + lastUrl + '; path=' + '/'
    if (lastUrl.indexOf('gov') !== -1) {
      if (index === 0) {
        // 个人登录
        location.href = 'https://qyfw.nbyz.gov.cn/api-gateway/jpaas-jisextend-quicklogin-server/front/zlb/login?type=2&redirectUrl=https://qyfw.nbyz.gov.cn'
      } else if (index === 1) {
        // 法人登录
        location.href = 'https://qyfw.nbyz.gov.cn/api-gateway/jpaas-jisextend-quicklogin-server/front/zlb/login?type=2&userType=legal&redirectUrl=https://qyfw.nbyz.gov.cn'
      }
    } else {
      if (index === 0) {
        // 个人登录
        location.href = 'https://qyfw.nbyz.cn/api-gateway/jpaas-jisextend-quicklogin-server/front/zlb/login?type=1&redirectUrl=https://qyfw.nbyz.cn'
      } else if (index === 1) {
        // 法人登录
        location.href = 'https://qyfw.nbyz.cn/api-gateway/jpaas-jisextend-quicklogin-server/front/zlb/login?type=1&userType=legal&redirectUrl=https://qyfw.nbyz.cn'
      }
    }

    // store.commit('changeLoginStatus', true)
    // store.commit('changeUserId', '111')
  },
  $loginOut: function () {
    store.commit('changeLoginStatus', false)
    store.commit('changeUserId', undefined)
    store.commit('changeUserType', undefined)
    // this.$router.push({ path: '/login' })
    cookieUtil.clearCookie('accessToken')
    location.href = 'https://portal.zjzwfw.gov.cn/uc/unifiedLogout'
    // const noPermissionList = [
    //   '/policy/enterpriseTestDetail'
    //   // '/appeal',
    //   // '/consultation'
    // ]
    // if (location.href.includes('myself') || noPermissionList.includes(this.$route.path)) {
    //   location.href = 'https://qyfw.nbyz.gov.cn/'
    // } else {
    //   // location.reload()
    // }
  }
}

for (const ex in commonFun) {
  Vue.prototype[ex] = commonFun[ex]
}
